import type { VoidFunctionComponent } from 'react';

import ModalViewRelationships from '../../dependencies/ModalViewRelationships';

import type { ModalProps } from '.';

const ViewRelationships: VoidFunctionComponent<ModalProps> = ({ projectRevision, modals }) => {
  const { isOpen, onClose } = modals.viewRelationshipsModal;
  const { revision, title } = modals.viewRelationshipsModal.context;

  if (!revision || !title) {
    return null;
  }

  return (
    <ModalViewRelationships
      parentLocator={projectRevision}
      revision={{
        locator: revision,
        project: {
          title,
        },
      }}
      show={isOpen}
      onHide={onClose}
  />
  );
};

export default ViewRelationships;
